<template>
  <div class="grid" :class="{ 'grid--nav-closed': closed }">
    <nav class="sub-navigation" :class="{ 'sub-navigation--closed': closed }">
      <slot name="content" v-if="!closed"> content </slot>
    </nav>
    <button class="hit-box" @click="toggle">
      ️
      <span class="button">
        <font-awesome-icon
          class="icon"
          :icon="['far', closed ? 'chevron-right' : 'chevron-left']"
        />
      </span>
    </button>
    <div class="content"><slot></slot></div>
  </div>
</template>

<script>
import { library } from "@fortawesome/fontawesome-svg-core";
import {
  faChevronLeft,
  faChevronRight,
} from "@fortawesome/pro-regular-svg-icons";

import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";

library.add(faChevronLeft, faChevronRight);

export default {
  name: "SubNavigation",
  components: { FontAwesomeIcon },
  data() {
    return {
      closed: false,
    };
  },
  methods: {
    toggle() {
      this.closed = !this.closed;
      this.$emit("subNavigationToggle", { closed: this.closed });
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../../../style_variables/style_variables.scss";

.sub-navigation {
  background: $white;
  width: 100%;
  max-width: 248px;
  height: 100%;
  border-right: 1px solid $grey_alabaster;
  padding: 40px 16px 12px 24px;

  &.sub-navigation--closed {
    padding: 0;
  }

  @media (max-width: 1000px) {
    display: none;
  }
}

.grid {
  height: 100%;
  display: grid;
  grid-template-columns: 248px 0 1fr;
  @media (max-width: 1000px) {
    grid-template-columns: 1fr;
  }

  &.grid--nav-closed {
    grid-template-columns: 20px 0 1fr;
    @media (max-width: 1000px) {
      grid-template-columns: 1fr;
    }
  }

  .hit-box {
    position: relative;
    border: none;
    display: flex;
    justify-content: center;
    align-items: center;
    top: 10px;
    left: -20px;
    width: 40px;
    height: 40px;
    background: none;
    padding: 0;
    cursor: pointer;
    z-index: 300;

    @media (max-width: 1000px) {
      display: none;
    }

    &:hover {
      > .button {
        background-color: $grey_mischka;
        color: $white;
      }
    }

    .button {
      background-color: $grey_alabaster;
      color: $blue;
      width: 28px;
      height: 28px;
      display: flex;
      justify-content: center;
      align-items: center;
      border-radius: 3px;
      transition: all 100ms cubic-bezier(0.4, 0, 0.2, 1);

      .icon {
        height: 16px;
        width: 16px;
      }
    }
  }

  .content {
    overflow: auto;
    height: calc(100vh - 56px);
    font-family: "Open Sans", sans-serif;
    font-weight: 400;
    font-size: 0.875rem;
  }
}
</style>
